export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POSTS = 'NEW_POSTS';
export const FETCH_BY_NAME = 'FETCH_BY_NAME';
export const FETCH_MEDIUM = 'FETCH_MEDIUM';